export class TargetPromotionRequest {
    promoId: string;
    requestType: string;
}
